import React, { useRef } from 'react';
import { Button, Space, Divider } from 'antd';
import { BoldOutlined, ItalicOutlined, UnderlineOutlined } from '@ant-design/icons';

function EditorEmail({ value, onChange }) {
  const editorRef = useRef(null);

  const exec = (cmd, val = null) => {
    editorRef.current.focus();
    document.execCommand(cmd, false, val);
    onChange(editorRef.current.innerHTML);
  };

  const handleInput = () => {
    onChange(editorRef.current.innerHTML);
  };

  const inserirVariavel = (variavel) => {
    editorRef.current.focus();
    document.execCommand('insertText', false, variavel);
    onChange(editorRef.current.innerHTML);
  };

  // Sincronizar value externo
  React.useEffect(() => {
    if (editorRef.current && value !== editorRef.current.innerHTML) {
      editorRef.current.innerHTML = value || '';
    }
  }, [value]);

  const VARIAVEIS = [
    { label: 'Nome cliente', valor: '{{cliente.nome}}' },
    { label: 'Nº proposta', valor: '{{proposta.numero}}' },
    { label: 'Valor proposta', valor: '{{proposta.valor}}' },
    { label: 'Vencimento boleto', valor: '{{boleto.vencimento}}' },
    { label: 'Linha digitável', valor: '{{boleto.linha_digitavel}}' },
    { label: 'Nº NFS-e', valor: '{{nfse.numero}}' },
    { label: 'Data NFS-e', valor: '{{nfse.data_emissao}}' },
    { label: 'Valor NFS-e', valor: '{{nfse.valor}}' },
    { label: 'Usuário', valor: '{{usuario.nome}}' },
    { label: 'Data hoje', valor: '{{data_hoje}}' },
  ];

  return (
    <div style={{ border: '1px solid #d9d9d9', borderRadius: 6, overflow: 'hidden' }}>
      {/* Barra de ferramentas */}
      <div style={{ background: '#fafafa', padding: '6px 8px', borderBottom: '1px solid #d9d9d9' }}>
        <Space size={4} wrap>
          <Button size="small" icon={<BoldOutlined />} onMouseDown={e => { e.preventDefault(); exec('bold'); }} title="Negrito" />
          <Button size="small" icon={<ItalicOutlined />} onMouseDown={e => { e.preventDefault(); exec('italic'); }} title="Itálico" />
          <Button size="small" icon={<UnderlineOutlined />} onMouseDown={e => { e.preventDefault(); exec('underline'); }} title="Sublinhado" />
          <Button size="small" onMouseDown={e => { e.preventDefault(); exec('insertUnorderedList'); }}>• Lista</Button>
          <Button size="small" onMouseDown={e => { e.preventDefault(); exec('insertParagraph'); }}>¶ Parágrafo</Button>
          <Divider type="vertical" />
          <span style={{ fontSize: 11, color: '#888' }}>Inserir variável:</span>
          {VARIAVEIS.map(v => (
            <Button key={v.valor} size="small" style={{ fontSize: 10 }}
              onMouseDown={e => { e.preventDefault(); inserirVariavel(v.valor); }}>
              {v.label}
            </Button>
          ))}
        </Space>
      </div>
      {/* Área de edição */}
      <div
        ref={editorRef}
        contentEditable
        onInput={handleInput}
        style={{
          minHeight: 200,
          padding: 12,
          outline: 'none',
          fontSize: 14,
          lineHeight: '21px',
          color: '#333',
          fontFamily: 'arial, sans-serif',
        }}
        suppressContentEditableWarning
      />
    </div>
  );
}

export default EditorEmail;
